import { app, authentication } from '@microsoft/teams-js'

const TEAMS_DETECTION_TIMEOUT_MS = 750

function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(
      () => reject(new Error('Teams detection timed out')),
      timeoutMs
    )

    promise
      .then(resolve)
      .catch(reject)
      .finally(() => window.clearTimeout(timeout))
  })
}

export async function isRunningInTeams(): Promise<boolean> {
  try {
    await withTimeout(app.initialize(), TEAMS_DETECTION_TIMEOUT_MS)
    const context = await app.getContext()
    return !!context.app.host.name
  } catch {
    return false
  }
}

export function authenticateWithTeams(): Promise<string> {
  return authentication.authenticate({
    url: `${window.location.origin}/login/teams-auth`,
    width: 600,
    height: 535,
  })
}

export function getTeamsSsoToken(): Promise<string> {
  return authentication.getAuthToken()
}
